import rolesRoutes from './roles.component'

const appRoutes = {
  routes: rolesRoutes,
}

export default appRoutes
